import { authnClient } from '@frontend/auth';
import { isWeaveTokenBufferActive, setLastVisitedPage, AUTH_CHECK_IGNORE_ROUTES } from '@frontend/auth-helpers';

export async function authQuickCheck() {
  const ignoreHosts = [
    // preview links use legacy auth
    'preview.weavelab.xyz',
    'f.weavedev.net',
    'edge.getweave.com',
  ];

  if (
    ignoreHosts.some((host) => location.hostname.includes(host)) ||
    AUTH_CHECK_IGNORE_ROUTES.some((route) => location.pathname.includes(route))
  ) {
    return;
  }

  const isUserAuthenticated = authnClient.isUserAuthenticated() || isWeaveTokenBufferActive();
  if (!isUserAuthenticated) {
    const originalURI = window.location.pathname + (window.location.search ?? '') + (window.location.hash ?? '');
    if (originalURI) {
      setLastVisitedPage(originalURI);
    }
    await authnClient.signIn({ meta: { source: 'auth_check' } }); // this will trigger the sign-in flow and top-level page navigation
  }
}
